import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UniversalSearchService {

  searchValue: string = '';
  searchValueChanged: Subject<void> = new Subject();

  constructor() { }

  setSearchValue(value: string): void {
    const trimmedValue = value.trim();
    if (trimmedValue !== this.searchValue) { // Only emit if the value actually changes
      this.searchValue = trimmedValue;
      this.searchValueChanged.next(); // Notify components about the search value change
    }
  }

  getSearchValue(): string {
    return this.searchValue;
  }
}
